var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_my-6" },
    [
      _c("h2", { staticClass: "gfu-hd gfu-hd--h2" }, [
        _vm._v("Feature comparison"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
        _vm._v(
          "Features that set " +
            _vm._s(_vm.platformName) +
            "  apart from the competition."
        ),
      ]),
      _vm._v(" "),
      _c("platform-feature-comparison", { staticClass: "_my-6" }),
      _vm._v(" "),
      _c("h2", { staticClass: "gfu-hd gfu-hd--h2" }, [
        _vm._v("End-to-end marketing support"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
        _vm._v(
          "Combine " +
            _vm._s(_vm.platformName) +
            " audiences with the experienced performance marketing team to maximize your success."
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "gfu-box gfu-box--flat gfu-box--huge _my-6 gfu-bt gfu-bt--b1",
        },
        [
          _c("div", { staticClass: "_flexwrap _mb-6" }, [
            _c("div", { staticClass: "gfu-1of1 gfu-1of2--m" }, [
              _c(
                "h3",
                {
                  staticClass:
                    "gfu-hd gfu-hd--h2 _mb-3 gfu-heading--top-divider _mb-3",
                },
                [_vm._v("Take advantage of our know-how")]
              ),
              _vm._v(
                "\n                Our in-house team turns data into results. We create high-impact visuals, manage your performance campaigns,\n                and share transparent updates every step of the way. Partner with us for your paid promotional strategy,\n                and you’ll also gain priority access to free placements across " +
                  _vm._s(_vm.platformName) +
                  "’s owned marketing channels.\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gfu-1of1 gfu-1of2--m _px-3 _tac" },
              [
                _c("themed-image", {
                  attrs: {
                    src: "/content/images/static/become-a-creator/arrow.svg",
                    alt: "Take advantage of our know-how",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "_tac" }, [
            _c("div", { staticClass: "_mb-1" }, [
              _vm._v("Sounds interesting?"),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--wide",
                attrs: { href: _vm.marketingServicesUrl },
              },
              [_vm._v("Learn more")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "gfu-hd gfu-hd--h2" }, [
        _vm._v("Get started with crowdfunding in just 5 steps"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
        _vm._v(
          "Making campaigns on " +
            _vm._s(_vm.platformName) +
            " is an easy and straightforward process."
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "gfu-box gfu-box--flat gfu-box--huge _my-6 gfu-bt gfu-bt--b1",
        },
        [
          _c(
            "div",
            { staticClass: "gfu-media _mb-6" },
            [
              _c("base-icon", {
                staticClass: "gfu-icon--big _mr-3 _tc--accent",
                attrs: { name: "user" },
              }),
              _vm._v(" "),
              _vm._m(0),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "gfu-media _mb-6" },
            [
              _c("base-icon", {
                staticClass: "gfu-icon--big _mr-3 _tc--accent",
                attrs: { name: "file-check" },
              }),
              _vm._v(" "),
              _vm._m(1),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "gfu-media _mb-6" },
            [
              _c("base-icon", {
                staticClass: "gfu-icon--big _mr-3 _tc--accent",
                attrs: { name: "pen-ruler" },
              }),
              _vm._v(" "),
              _vm._m(2),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "gfu-media _mb-6" },
            [
              _c("base-icon", {
                staticClass: "gfu-icon--big _mr-3 _tc--accent",
                attrs: { name: "rocket" },
              }),
              _vm._v(" "),
              _vm._m(3),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "gfu-media _mb-6" },
            [
              _c("base-icon", {
                staticClass: "gfu-icon--big _mr-3 _tc--accent",
                attrs: { name: "truck-fast" },
              }),
              _vm._v(" "),
              _vm._m(4),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "_tac" }, [
            _c(
              "a",
              {
                staticClass:
                  "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--wide",
                attrs: { href: _vm.becomeCreatorUrl },
              },
              [_vm._v("Launch your project")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h4", { staticClass: "gfu-hd gfu-hd--h3 _mb-1 gfu-icon--hd" }, [
        _vm._v("Become a creator"),
      ]),
      _vm._v(
        "\n                Create a free account. It's easy, just a few clicks.\n            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h4", { staticClass: "gfu-hd gfu-hd--h3 _mb-1 gfu-icon--hd" }, [
        _vm._v("Submit data"),
      ]),
      _vm._v(
        "\n                Share with us some information about yourself. Make sure your project is compliant with our terms of service.\n            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h4", { staticClass: "gfu-hd gfu-hd--h3 _mb-1 gfu-icon--hd" }, [
        _vm._v("Publish a preview page"),
      ]),
      _vm._v(
        "\n                Present your project, show its best features and gather followers. Let backers know what it is about.\n            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h4", { staticClass: "gfu-hd gfu-hd--h3 _mb-1 gfu-icon--hd" }, [
        _vm._v("Launch!"),
      ]),
      _vm._v(
        "\n                Once you're ready, set the timer to start the campaign. We'll review it and give you some hints if anything needs improving. Then, everything is in your and backers' hands!\n            "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h4", { staticClass: "gfu-hd gfu-hd--h3 _mb-1 gfu-icon--hd" }, [
        _vm._v("Finalize the campaign"),
      ]),
      _vm._v(
        "\n                After successful funding and when your project is almost ready, you can set up a pledge manager to handle pledges and prepare delivery to the backers.\n            "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }